import * as Yup from "yup";
import { EVetExamFields } from "./options";

export const getValidationSchema = (examReasonsWithConclusion: string[]) => {
  return Yup.object().shape({
    [EVetExamFields.RESULT]: Yup.string().required(
      "Please make an exam decision"
    ),
    [EVetExamFields.CONCLUSION]: Yup.string().when(EVetExamFields.REASON, {
      is: value => examReasonsWithConclusion.includes(value),
      then: schema => schema.required("Please give an exam conclusion"),
      otherwise: schema => schema.notRequired()
    })
  });
};
